import styled from 'styled-components';
import { variants } from '../map';
export const ParagraphBox = styled.p.withConfig({
  displayName: "ParagraphBox",
  componentId: "sc-1o1vp14-0"
})(["margin:0;", " & + &{margin:0.5em 0 0;}"], variants.standard);
ParagraphBox.displayName = 'ParagraphBox';